const EDITABLE_FIELDS = [
  ["facility_type", "imageFileIndex.timeseries.summary.facilityType", "설비 구분"],
  ["facility_name", "imageFileIndex.timeseries.summary.facilityName", "설비명"],
  ["part_name", "imageFileIndex.timeseries.summary.partName", "부품명"],
];

/*
 * TimeseriesEditModal 역할:
 * - 시계열 진단 보고서에서 수정 가능한 요약 메타데이터와 종합의견만 모달 안에서 편집한다.
 * - 다른 보고서와 같은 저장/취소 흐름을 따르되, 시계열 보고서 전용 편집 항목만 제한해서 노출한다.
 */
export default function TimeseriesEditModal({
  file,
  sourceInspectionResult = "",
  generatedOpinion = "",
  handleChange,
  onCancel,
  onSave,
  isSaving,
  hasChanges,
  t,
}) {
  const currentInspectionResult = String(file?.inspection_result ?? "");
  const baseInspectionResult = String(sourceInspectionResult ?? "");
  const opinionValue =
    currentInspectionResult !== baseInspectionResult
      ? currentInspectionResult
      : generatedOpinion;

  return (
    <div
      className="reportEditModalOverlay"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="reportEditModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="timeseries-report-edit-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="reportEditModalHeader">
          <div className="titleBox">
            <h3 id="timeseries-report-edit-title">
              {t("editorBtnBox.editButton")}
            </h3>
            <p>
              {t("imageFileIndex.timeseries.excel.title", {
                defaultValue: "시계열 진단 보고서",
              })}
            </p>
          </div>

          <button
            type="button"
            className="iconBtn"
            onClick={onCancel}
            aria-label={t("editorBtnBox.cancelButton")}
          >
            X
          </button>
        </div>

        <div className="reportEditModalBody">
          <div className="reportEditGrid">
            {EDITABLE_FIELDS.map(([id, labelKey, fallback]) => (
              <label className="reportEditField" key={id}>
                <span className="label">
                  {t(labelKey, {
                    defaultValue: fallback,
                  })}
                </span>
                <input
                  id={id}
                  type="text"
                  value={file?.[id] ?? ""}
                  onChange={handleChange}
                />
              </label>
            ))}
          </div>

          <label className="reportEditField textareaField">
            <span className="label">
              {t("imageFileIndex.timeseries.summary.comprehensiveOpinion", {
                defaultValue: "종합의견",
              })}
            </span>
            <textarea
              id="inspection_result"
              value={opinionValue}
              onChange={handleChange}
            />
          </label>
        </div>

        <div className="reportEditModalFooter">
          <button
            type="button"
            className="ghostBtn"
            onClick={onCancel}
            disabled={isSaving}
          >
            {t("editorBtnBox.cancelButton")}
          </button>
          <button
            type="button"
            className="primaryBtn"
            onClick={onSave}
            disabled={!hasChanges || isSaving}
          >
            {isSaving ? "Saving..." : t("editorBtnBox.saveButton")}
          </button>
        </div>
      </div>
    </div>
  );
}
